import React, { Component } from 'react';
import { AdditionalInfo } from './AdditionalInfo';
import { NotPickedReason } from './NotPickedReason';
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon, } from "@fortawesome/react-fontawesome";
export class WHItemInfo extends Component {

    constructor(props) {
        super(props);
        this.getQtyText = this.getQtyText.bind(this);
        this.canEditQty = this.canEditQty.bind(this);
    }

    getQtyText(item) {
        if (item.qtyCancelled > 0) {
            return (<b>Cancelled: {item.qtyCancelled}</b>)
        } else if (item.isBackordered) {
            return (<b>Backordered: {item.qtyBackordered}</b>)
        } else {
            return (<b>Remain: {item.quantity}</b>)
        }
    }

    canEditQty(item, itemInfo, onHandQty) {
        var sufficientQty = (onHandQty > 0 || itemInfo.bins[0].bin == 'Non-Inventory');
        var canEdit =
            this.props.canEditQty
            &&
            (item.quantity + item.quantityPicked) >= this.props.multiScanThreshold
            &&
            !item.pickLater
            &&
            !item.isBackordered
            &&
            !item.needsSerialNum
            &&
            !item.isGiftCard
            &&
            sufficientQty;
        return canEdit;
    }


    render() {
        var lineStatusClass = this.props.getLineStatus(this.props.item);
        var itemInfo = this.props.itemInfo[this.props.item.itemId];
        var item = this.props.item;
        var binIndex = itemInfo.binIndex;
        var bin = itemInfo.bins[binIndex].bin;
        if (!bin || bin === "none") {
            bin = "No Bin Available";
        }
        var onHandQty = itemInfo.locationQtyInfo[this.props.location] ? itemInfo.locationQtyInfo[this.props.location].qtyOnHand : 0;
        if (!onHandQty) {
            onHandQty = 0
        }
        var lineId = item.lineId;
        var itemName = item.itemName;
        var allBinsEmpty = itemInfo.allBinsEmpty;
        var itemOptions = itemInfo.itemOptions;
        return (
            <div className={lineStatusClass} id={lineId} key={"wh"+lineId}>
                <div className='item-info grid-container'>                
                    <div className='bin'><b>Bin: {bin}</b></div>
                    <div className='itemName'>
                        <b>{itemName}</b>
                        {
                            itemOptions
                            &&
                            (
                                <div>
                                    <b className="itemOptions">{itemOptions}</b>
                                </div>
                            )
                        }
                    </div>
                    <AdditionalInfo
                        item={item}
                        additionalInfoOptions={this.props.additionalInfoOptions}
                        editInputField={this.props.editInputField}
                        updateGiftCardNum={this.props.updateGiftCardNum}
                        updateSerialNum={this.props.updateSerialNum}
                    />
                    <div className="qtyInfo">
                        {this.getQtyText(item)}
                        <b>Picked: {item.quantityPicked} {this.canEditQty(item, itemInfo, onHandQty) && <b onClick={(e) => { this.props.startBinQtyEdit(item.lineId) }}><FontAwesomeIcon icon={faPenToSquare} /></b>}</b> 
                        <b>QOH:{onHandQty}</b>
                    </div>
                    <div className='buttons'>
                        {
                            (!item.isBackordered && !item.pickLater)
                            &&
                            <div className="binButtons">
                                {
                                    (item.quantity > 0 && itemInfo.bins.length > 1 && itemInfo.binIndex > 0) && <button onClick={() => this.props.changeBin(lineId, true)}>Previous Bin</button>
                                }
                                {
                                    (item.quantity > 0 && itemInfo.bins.length > 1 && itemInfo.binIndex + 1 < itemInfo.bins.length) && <button onClick={() => this.props.changeBin(lineId, false)}>Next Bin</button>
                                }
                            </div>
                        }
                        
                        {
                            //Backordered would need to be added if we end up using that
                            item.pickLater && <button onClick={() => this.props.pickNow(lineId)}>Pick Now</button>
                        }
                        {
                            item.qtyCancelled > 0 && <button onClick={() => this.props.undoCancel(lineId)}>Undo Cancel</button>
                        }
                        {
                            item.isBackordered && <button onClick={() => this.props.undoBackorder(lineId)}>Undo Backorder</button>
                        }
                        {
                            (
                                item.quantity > 0
                                &&
                                (allBinsEmpty || itemInfo.bins.length === 1)
                                &&
                                (!item.isBackordered && !item.pickLater)
                            )
                            &&
                            <NotPickedReason
                                lineId={lineId}
                                doNotPick={this.props.doNotPick}
                                backorderItem={this.props.backorderItem}
                                showBackorder={this.props.canBackorder}
                                canCancel={this.props.canCancel}
                                cancelItem={this.props.cancelItem}
                            />
                        }
                    </div>
                    <div className='slot'>
                        <h1>{item.slot}</h1>
                    </div>
                </div>
            </div>
        );
    }
}
